import { AvatarImage } from "@design-system/components";
import React from "react";

import { useLogo } from "../queries";

import { FallbackLogo } from "./fallback-logo";

function Logo() {
  const { logoUrl } = useLogo();

  if (!logoUrl) {
    return <FallbackLogo />;
  }

  return <AvatarImage src={logoUrl} alt="Logo" />;
}

export { Logo };
